/**
 * MoreContent content observable.
 */
import Main from '../../types/enums/main';
import moreContentRequest from './moreContentRequest';
import { Observable } from 'rxjs';

export default function contentObservable() {
  return new Observable((subscriber) => {
    moreContentRequest().then((data) => {
      subscriber.next({ data, type: Main.RAILS });
      subscriber.complete();
    });
  });
}
